import { Listing } from "./Listing"

export const LocationListing = Listing


// WEBPACK FOOTER //
// ./src/inventory/sections/location/index.ts